import { hShortenNumber } from '@/utils/helpers';

export default {
  name: 'phone-number-input',
  data() {
    return {
      phoneNumber: '123 456 789',
    };
  },
  methods: {
    validatePhoneNumberOnKeyup() {
      const number = this.phoneNumber.replace(/[^0-9]/g, '');
      this.phoneNumber = hShortenNumber(number).replace(/(.{3})/g, '$1 ').trim();
    },
    getNumber() {
      this.$emit('get-number');
    },
  },
}
